export enum SeasonStatuses {
  Active = "ACTIVE",
  Complete = "COMPLETE",
  Draft = "DRAFT",
  Inactive = "INACTIVE",
  Pending = "PENDING",
}
